import ContentList from './ContentList';
export type { IContentListProps } from './ContentList.types';

export default ContentList;
